export const isValidDate = (date: Date | undefined) => {
  if (date) {
    if (!isNaN(date.getDate())) {
      return true;
    }
  }

  return false;
};

export const convertStringToDate = (input: string): Date => {
  return new Date(Date.parse(input));
};

export const convertDateToDateString = (input: Date): string => {
  return input.toISOString().split("T")[0];
};

export const getMonthStart = (date: Date | string) => {
  let newDate;

  if (typeof date === "string") {
    newDate = convertStringToDate(date);
  } else {
    newDate = date;
  }

  if (!isValidDate(newDate)) {
    return;
  }

  return new Date(newDate.getUTCFullYear(), newDate.getUTCMonth(), 1, 0);
};

export const getMonthEnd = (date: Date | string) => {
  let newDate;

  if (typeof date === "string") {
    newDate = convertStringToDate(date);
  } else {
    newDate = date;
  }

  if (!isValidDate(newDate)) {
    return;
  }

  return new Date(newDate.getUTCFullYear(), newDate.getUTCMonth() + 1, 0);
};

export const calculateMinMonthlyDate = (date: Date) => {
  if (date > new Date(date.getFullYear(), date.getMonth(), 5)) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  } else {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
  }
};
